import { getColumnsByNames } from './all-top10-columns-config';

export const top10SourceAllowedColumns = getColumnsByNames([
    { name: 'rule' },
    { name: 'src' },
    { name: 'dport' },
    { name: 'proto' },
    { name: 'bytes', width: '34%'  }
]);